import { Address, erc20Abi } from "viem"

import { MEZO_CHAIN, ONE_SECOND_IN_MILLISECONDS } from "#/shared/constants"

import { useEstimateTransactionGas } from "../contract"

const refetchInterval = ONE_SECOND_IN_MILLISECONDS * 10 // 10 seconds
const staleTime = refetchInterval

export default function useEstimateApproveERC20TokenGas(
  tokenAddress: Address,
  spender: Address,
  amount: bigint,
  chainId: number = MEZO_CHAIN.id,
) {
  return useEstimateTransactionGas(
    {
      abi: erc20Abi,
      functionName: "approve",
      args: [spender, amount],
      address: tokenAddress,
    },
    {
      chainId,
      query: {
        staleTime,
        refetchInterval,
      },
    },
  )
}
